import {
  Companion_getInstance1exe5oe9i5w84 as Companion_getInstance,
  get_entries3dia5qzc4pxls as get_entries,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  And1a3dbpwh0hxmu as And,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { CareProgramTemplatemobjbqq2s74k as CareProgramTemplate } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_careTime1h5171nvh773w as get_careTime,
  get_availableAsIntermittent2wvvnkqvc4qfv as get_availableAsIntermittent,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  filterMenu2fz1h01y9a2vu as filterMenu,
  FilterChiptjf5vayz5x4r as FilterChip,
  filterChip1bkihjb9h4931 as filterChip,
} from '../components/filters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { rowOf3phwx1yo72ntt as rowOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function CareProgramTemplateFilters$Companion$$childSerializers$_anonymous__ak6x8c() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, CareProgramTemplateFilters$Companion$$childSerializers$_anonymous__ak6x8c), null];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.rates.CareProgramTemplateFilters', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('careTime', true);
        tmp0_serialDesc.addElement_5pzumi_k$('availableAsIntermittent', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_lmc01v_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.careTime_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.careTime_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.availableAsIntermittent_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, BooleanSerializer_getInstance(), value.availableAsIntermittent_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_lmc01v_k$(encoder, value instanceof CareProgramTemplateFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, tmp7_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, tmp7_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareProgramTemplateFilters().new_org_thecommunitygroupinc_cares_views_rates_CareProgramTemplateFilters_10qxyy_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(tmp0_cached[0].get_value_j01efc_k$()), get_nullable(BooleanSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var CareProgramTemplateFiltersClass;
function CareProgramTemplateFilters() {
  if (CareProgramTemplateFiltersClass === VOID) {
    class $ {
      constructor(careTime, availableAsIntermittent) {
        Companion_getInstance_0();
        careTime = careTime === VOID ? null : careTime;
        availableAsIntermittent = availableAsIntermittent === VOID ? null : availableAsIntermittent;
        this.careTime_1 = careTime;
        this.availableAsIntermittent_1 = availableAsIntermittent;
      }
      toCondition_oj74tc_k$() {
        var tmp = Always_getInstance();
        var tmp0_safe_receiver = this.careTime_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          tmp_0 = eq(get_careTime(it), tmp0_safe_receiver);
        }
        var tmp_2 = tmp_0;
        var tmp1_safe_receiver = this.availableAsIntermittent_1;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$11);
          tmp_3 = eq(get_availableAsIntermittent(it_0), tmp1_safe_receiver);
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp, tmp_2, tmp_3]));
      }
      activeCount_htest3_k$() {
        var count = 0;
        if (!(this.careTime_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.availableAsIntermittent_1 == null)) {
          count = count + 1 | 0;
        }
        return count;
      }
      copy_7ym98p_k$(careTime, availableAsIntermittent) {
        return new (CareProgramTemplateFilters())(careTime, availableAsIntermittent);
      }
      copy$default_6yyadv_k$(careTime, availableAsIntermittent, $super) {
        careTime = careTime === VOID ? this.careTime_1 : careTime;
        availableAsIntermittent = availableAsIntermittent === VOID ? this.availableAsIntermittent_1 : availableAsIntermittent;
        return $super === VOID ? this.copy_7ym98p_k$(careTime, availableAsIntermittent) : $super.copy_7ym98p_k$.call(this, careTime, availableAsIntermittent);
      }
      toString() {
        return 'CareProgramTemplateFilters(careTime=' + toString(this.careTime_1) + ', availableAsIntermittent=' + this.availableAsIntermittent_1 + ')';
      }
      hashCode() {
        var result = this.careTime_1 == null ? 0 : this.careTime_1.hashCode();
        result = imul(result, 31) + (this.availableAsIntermittent_1 == null ? 0 : getBooleanHashCode(this.availableAsIntermittent_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareProgramTemplateFilters()))
          return false;
        if (!equals(this.careTime_1, other.careTime_1))
          return false;
        if (!(this.availableAsIntermittent_1 == other.availableAsIntermittent_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_rates_CareProgramTemplateFilters_10qxyy_k$(seen0, careTime, availableAsIntermittent, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.careTime_1 = null;
        else
          $this.careTime_1 = careTime;
        if (0 === (seen0 & 2))
          $this.availableAsIntermittent_1 = null;
        else
          $this.availableAsIntermittent_1 = availableAsIntermittent;
        return $this;
      }
    }
    initMetadataForClass($, 'CareProgramTemplateFilters', CareProgramTemplateFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    CareProgramTemplateFiltersClass = $;
  }
  return CareProgramTemplateFiltersClass;
}
function careProgramTemplateFilters(_this__u8e3s4, target) {
  var tmp = careProgramTemplateFilters$slambda(target);
  return filterMenu(_this__u8e3s4, target, tmp, ($this$filterMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label = 'Care time';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$filterMenu.willAddChild_hz2iwc_k$(element);
    element.set_content_lzqutq_k$(label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_0 = themed(element, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_1 = weight(element_0, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Select())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    var tmp = careProgramTemplateFilters$lambda$lambda;
    var tmp_0 = target.lens_u4wb4z_k$(tmp, careProgramTemplateFilters$lambda$lambda_0);
    var tmp_1 = _Constant___init__impl__v45mub(plus(listOf_0(null), get_entries()));
    element_1.bind_64a41i_k$(tmp_0, new (Constant())(tmp_1), careProgramTemplateFilters$lambda$lambda_1);
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
    element.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label_0 = 'Intermittent eligible';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$(label_0);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_2 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (RowOrCol())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_2.willAddChild_hz2iwc_k$(element_3);
    element_3.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_3 = weight(element_3, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (Select())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    this_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_2 = careProgramTemplateFilters$lambda$lambda_2;
    var tmp_3 = target.lens_u4wb4z_k$(tmp_2, careProgramTemplateFilters$lambda$lambda_3);
    var tmp_4 = _Constant___init__impl__v45mub(listOf([null, true, false]));
    element_4.bind_64a41i_k$(tmp_3, new (Constant())(tmp_4), careProgramTemplateFilters$lambda$lambda_4);
    element_4.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_4);
    element_3.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_2);
    return Unit_instance;
  });
}
function careProgramTemplateFilterChips(_this__u8e3s4, filter) {
  var chips = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).careTime_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.add_utx5q5_k$(new (FilterChip())(tmp0_safe_receiver, tmp0_safe_receiver.displayName_1, careProgramTemplateFilterChips$lambda$slambda(filter)));
    }
    var tmp1_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).availableAsIntermittent_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = tmp1_safe_receiver ? 'Intermittent eligible' : 'Not intermittent eligible';
      this_0.add_utx5q5_k$(new (FilterChip())(tmp1_safe_receiver, tmp, careProgramTemplateFilterChips$lambda$slambda_0(filter)));
    }
    return this_0.build_nmwvly_k$();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var this_0 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(chips).isEmpty_y1axqb_k$();
  }), ListSemantic_getInstance());
  var vertical = false;
  var horizontal = true;
  var tmp = beforeSetup(this_0, ($this$beforeSetup) => {
    (new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical)).set_showScrollBars_vutwwi_k$(false);
    return Unit_instance;
  });
  var tmp_0 = careProgramTemplateFilterChips$lambda;
  var tmp_1 = careProgramTemplateFilterChips$lambda_0;
  rowOf(tmp, chips, tmp_0, VOID, tmp_1, careProgramTemplateFilterChips$lambda_1);
}
function careProgramTemplateFilters$slambda($target) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $target.set_revjhg_k$(new (CareProgramTemplateFilters())(), $completion);
    return Unit_instance;
  }), 0);
}
function careProgramTemplateFilters$lambda$lambda(it) {
  return it.careTime_1;
}
function careProgramTemplateFilters$lambda$lambda_0(old, new_0) {
  return old.copy$default_6yyadv_k$(new_0);
}
function careProgramTemplateFilters$lambda$lambda_1(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? 'All' : tmp1_elvis_lhs;
}
function careProgramTemplateFilters$lambda$lambda_2(it) {
  return it.availableAsIntermittent_1;
}
function careProgramTemplateFilters$lambda$lambda_3(old, new_0) {
  return old.copy$default_6yyadv_k$(VOID, new_0);
}
function careProgramTemplateFilters$lambda$lambda_4(it) {
  if (it == null)
    return 'All';
  return it ? 'Eligible' : 'Not eligible';
}
function careProgramTemplateFilterChips$lambda$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_6yyadv_k$(null);
  }), 1);
}
function careProgramTemplateFilterChips$lambda$slambda($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, careProgramTemplateFilterChips$lambda$slambda$slambda(), $completion);
    return Unit_instance;
  }), 1);
}
function careProgramTemplateFilterChips$lambda$slambda$slambda_0() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_6yyadv_k$(VOID, null);
  }), 1);
}
function careProgramTemplateFilterChips$lambda$slambda_0($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, careProgramTemplateFilterChips$lambda$slambda$slambda_0(), $completion);
    return Unit_instance;
  }), 1);
}
function careProgramTemplateFilterChips$lambda(it) {
  return to(it.value_1, it.label_1);
}
function careProgramTemplateFilterChips$lambda_0($this$rowOf) {
  return get_centered($this$rowOf);
}
function careProgramTemplateFilterChips$lambda_1($this$rowOf, item) {
  var tmp = lens(item, careProgramTemplateFilterChips$lambda$lambda);
  filterChip($this$rowOf, tmp, VOID, careProgramTemplateFilterChips$lambda$slambda_1(item));
  return Unit_instance;
}
function careProgramTemplateFilterChips$lambda$lambda(it) {
  return it.label_1;
}
function careProgramTemplateFilterChips$lambda$slambda_1($item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    yield* (yield* await_0(this_0, $completion)).remove_94srgz_k$($completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  CareProgramTemplateFilters as CareProgramTemplateFilters33ni83g3dp3j2,
  careProgramTemplateFilterChips as careProgramTemplateFilterChips227j6w4asz7y6,
  careProgramTemplateFilters as careProgramTemplateFiltersmm32deyer0fw,
};
//endregion

//# sourceMappingURL=CareProgramTemplateFilters.mjs.map
